import { Card, FormField, Heading, InputWidth, ReadOnlyField } from '@msaf/core-react'
import { WellLogOrSurveyFields } from '../../../../types/form-types'

interface WellLogOrSurveyInterface {
  fields: Partial<WellLogOrSurveyFields>
  index: number
  isLoading: boolean
}

export default function WellLogOrSurveyView({ fields, index, isLoading }: WellLogOrSurveyInterface) {
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        Survey {index + 1}
      </Heading>

      <FormField isSkeleton={isLoading} label='Survey type' labelId='surveyType'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='surveyType' value={`${fields['surveyType'] ?? ''}`} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Date' labelId='date'>
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='date'
          value={`${fields['date'] ?? ''}`}
        />
      </FormField>
      <FormField isSkeleton={isLoading} label='Data sheet' labelId='dataSheetUri'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='dataSheetUri' value={`${fields['dataSheetUri'] ?? ''}`} />
      </FormField>
    </Card>
  )
}
